<div class="costField">
  <pp-select
    class="costField__select"
    [ppItems]="filteredAssetSites"
    [ppSelectedItem]="assetSites[assetSiteIndex]"
    (ppSelectItem)="selectSite($event)"
    [ppNoSearchBar]="true"
    >
    <ng-container selected>
      @if (assetSiteIndex !== -1) {
        <span class="uerSettings__select-content">
          {{ assetSites[assetSiteIndex].label }}
        </span>
      }

      @if (assetSiteIndex === -1) {
        <span class="costField__input__placeholder">
          {{ 'select_site' | ppTranslate }}
        </span>
      }
    </ng-container>
  </pp-select>

  <div class="verticalLine"></div>

  <pp-select
    class="costField__select"
    [ppItems]="filteredBudgetFields"
    [ppSelectedItem]="workspaceCustomFields[workspaceBudgetIndex]"
    [class.costField__select--emptyError]="budgetFieldError"
    (ppSelectItem)="selectBudgetField($event)"
    [ppNoSearchBar]="true"
    [ppDisabled]="filteredBudgetFields.length === 0"
    ppTooltip
    [ppTitle]="filteredBudgetFields.length === 0 ? ('no_budget_fields' | ppTranslate) : ''"
    >
    <ng-container selected>
      @if (workspaceBudgetIndex !== -1 && !budgetFieldError) {
        <span
          class="uerSettings__select-content"
          >
          {{ workspaceCustomFields[workspaceBudgetIndex].label }}
        </span>
      }

      @if (workspaceBudgetIndex === -1 && !budgetFieldError) {
        <span
          class="costField__input__placeholder"
          >
          {{ 'select_custom_field' | ppTranslate }}
        </span>
      }

      @if (budgetFieldError) {
        <span class="costField__input__error">
          {{ 'reconfigure' | ppTranslate }}
        </span>
      }
    </ng-container>
  </pp-select>
  <div class="compareArrows">
    <pp-icon
      [ppDisplayContents]="true"
      [ppSrc]="EIconPath.ICON_COMPARE_ARROWS"
      ppColor="inherit"
    ></pp-icon>
  </div>

  <pp-select
    class="costField__select"
    [ppItems]="filteredCostFields"
    [ppSelectedItem]="workspaceCustomFields[workspaceCostIndex]"
    [class.costField__select--emptyError]="costFieldError"
    (ppSelectItem)="selectCostField($event)"
    [ppNoSearchBar]="true"
    [ppDisabled]="filteredCostFields.length === 0"
    ppTooltip
    [ppTitle]="filteredCostFields.length === 0 ? ('no_cost_fields' | ppTranslate) : ''"
    >
    <ng-container selected>
      @if (workspaceCostIndex !== -1 && !costFieldError) {
        <span
          class="uerSettings__select-content"
          >
          {{ workspaceCustomFields[workspaceCostIndex].label }}
        </span>
      }

      @if (workspaceCostIndex === -1 && !costFieldError) {
        <span
          class="costField__input__placeholder"
          >
          {{ 'select_custom_field' | ppTranslate }}
        </span>
      }

      @if (costFieldError) {
        <span class="costField__input__error">
          {{ 'reconfigure' | ppTranslate }}
        </span>
      }
    </ng-container>
  </pp-select>

  @if (ppItemRows.length > 1) {
    <button class="deleteButton" (click)="deleteRow()">
      <pp-icon [ppSrc]="EIconPath.ICON_BIN_24" ppClass="setSize24" ppColor="red"></pp-icon>
    </button>
  }
</div>
